import React from 'react'
import { Redirect } from 'react-router-dom'
import { navigationPaths } from '../constants/paths'

export default function Dashboard() {
  return <Redirect to={navigationPaths.shopOrdersIndex()} />
}
